import { useSubsequentEffect } from '@carvana/merch-react-hooks';
import COOKIES from '~/constants/cookies';
import { useIsTradeInApplied } from '~/context/common/TradeContext';
import BrowserCookies from '~/utilities/BrowserCookies';

export default function useToggleAppliedTradeCookie(): void {
  const isTradeInApplied = useIsTradeInApplied();

  useSubsequentEffect(() => {
    if (isTradeInApplied) {
      BrowserCookies.remove(COOKIES.tradeInApplied);
    } else {
      const expires = new Date();
      expires.setDate(expires.getDate() + 7);

      BrowserCookies.set(COOKIES.tradeInApplied, String(false), { expires });
    }
  }, [isTradeInApplied]);
}
